const reconciliationOppStage = {
  COMPLETED: 'COMPLETED',
  CANCELLATION: 'CANCELLATION',
  CANCELLATION_IN_PROGRESS: 'CANCELLATION_IN_PROGRESS',
};

export default reconciliationOppStage;
